/**
 * Loads the Facebook Pixel script and sends events passed down by the server
 */

import { MiaPlaza } from "@/Reinforced.Typings";

export default class FacebookPixel {
	private readonly options: MiaPlaza.Control.Tracking.IFacebookPixelTrackingOptions;
	private loaded = false;

	constructor(options: MiaPlaza.Control.Tracking.IFacebookPixelTrackingOptions) {
		this.options = options;
	}

	public load(): void {
		if (this.loaded) {
			return;
		}
		this.loaded = true;

		// Snippet taken from https://developers.facebook.com/docs/meta-pixel/get-started/
		const facebookPixelJs = "!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');";
		(new Function(facebookPixelJs))();

		fbq("init", this.options.Id);
		fbq("track", "PageView");

		for (const event of this.options.Events) {
			fbq("track", event.EventType, JSON.parse(event.CustomData), { eventID: event.EventId });
		}
	}
}
